import React from "react";
import { Box, Flex, Grid, Text } from "theme-ui";
import { typography } from "../../../styles/theme";
import { InfoTile } from "../../molecules";
import { Button } from "../../atoms";
import { navigate } from "@reach/router";

const FeaturesSectionHome = ({ heading, subheading, featuresData, code }) => {
  return (
    <Box
      sx={{
        px: ["1rem", "1rem", "2rem", "2rem"],
        mb: ["4rem", "4rem", "7rem", "7rem"],
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          mb: ["3rem", "3rem", "3rem", "4rem"],
          mx: ["auto", "auto", "5.813rem", "auto"],
        }}
      >
        {heading}
        <Text sx={{ ...typography.textMd400 }}>{subheading}</Text>
      </Box>

      <Grid
        columns={[1, 1, 1, 2]}
        sx={{
          gap: "1.5rem",
          maxWidth: ["25.188rem", "25.188rem", "29.563rem", "60.625rem"],
          margin: "auto",
        }}
      >
        {featuresData?.slice(0, 4).map(
          (
            {
              feature: { title, desc, iconName, iconTheme, backgroundColor },
            },
            i
          ) => {
            return (
              <InfoTile
                key={`infotile-${i}`}
                title={title}
                content={desc}
                iconName={iconName}
                theme={iconTheme}
                backgroundColor={backgroundColor}
                hideHoverBgColor="true"
                customStyles={{
                  maxWidth: [
                    "25.188rem",
                    "25.188rem",
                    "29.563rem",
                    "29.563rem",
                  ],
                  border: "none",
                }}
              />
            );
          }
        )}
      </Grid>

      <Box
        sx={{
          maxWidth: ["25.188rem", "25.188rem", "29.563rem", "60.625rem"],
          margin: "auto",
          mt: "1.5rem",
        }}
      >
        {featuresData?.slice(-1).map(
          (
            {
              feature: { title, desc, iconName, iconTheme, backgroundColor },
            },
            i
          ) => {
            return (
              <InfoTile
                key={`infotile-last-${i}`}
                title={title}
                content={desc}
                iconName={iconName}
                theme={iconTheme}
                backgroundColor={backgroundColor}
                hideHoverBgColor="true"
                customStyles={{
                  maxWidth: ["100%"],
                  border: "none",
                }}
              />
            );
          }
        )}
      </Box>
      <Flex sx={buttonContainerStyles}>
        {code !== "ID" && (
          <Button
            variant="filled"
            size="large"
            id={`home_explore_hrms_${code.toLowerCase()}_btn`}
            onClick={() => navigate("/complete-guide-hrms/")}
          >
            Explore HRMS
          </Button>
        )}
        <Button
          variant="filled"
          size="large"
          id={`home_explore_payroll_${code.toLowerCase()}_btn`}
          onClick={() =>
            navigate(
              code === "ID"
                ? "/indonesia/payroll-software/"
                : "/complete-guide-payroll/"
            )
          }
        >
          Explore Payroll
        </Button>
      </Flex>
    </Box>
  );
};

const { buttonContainerStyles } = {
  buttonContainerStyles: {
    margin: "auto",
    gap: ["1.5rem", "1.5rem", "3rem", "1rem"],
    flexDirection: ["column", "column", "row", "row"],
    justifyContent: "center",
    mt: ["1.5rem", "1.5rem", "3rem", "4rem"],
    "@media (max-width: 599px)": {
      width: "12.5rem",
    },
  },
};

export default FeaturesSectionHome;
